var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{attrs:{"size":_vm.size,"color":"teal"}},[_c('span',{staticClass:"white--text"},[_vm._v(_vm._s(_vm.strRole))])])}
var staticRenderFns = []

export { render, staticRenderFns }